module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst {\nuserAttributes,\noperations,\n} = model.activationData || {}\nconst {\npassword,\n} = userAttributes || {}\nconst {\nsetEmailConfirmed,\nsetMobileConfirmed,\nsetStatusActive,\n} = operations || {}\nconst messages = []\nif(setStatusActive)     messages.push(__('status.activationRegister.successUserMessages.setStatusActive'));\nif(setEmailConfirmed)   messages.push(__('status.activationRegister.successUserMessages.setEmailConfirmed'));\nif(setMobileConfirmed)  messages.push(__('status.activationRegister.successUserMessages.setMobileConfirmed'));\nif(password)            messages.push(__('status.activationRegister.successUserMessages.password'));\n%><div>\n<ul>\n<%- messages.map(value => `<li>${value}</li>`).join('') %>\n<%\nif(password){\n%><li class=\"highlight\"><%= password %></li><%\n}\n%>\n</ul>\n</div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\credentials\\activationDataHandler.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const {
userAttributes,
operations,
} = model.activationData || {}
const {
password,
} = userAttributes || {}
const {
setEmailConfirmed,
setMobileConfirmed,
setStatusActive,
} = operations || {}
const messages = []
if(setStatusActive)     messages.push(__('status.activationRegister.successUserMessages.setStatusActive'));
if(setEmailConfirmed)   messages.push(__('status.activationRegister.successUserMessages.setEmailConfirmed'));
if(setMobileConfirmed)  messages.push(__('status.activationRegister.successUserMessages.setMobileConfirmed'));
if(password)            messages.push(__('status.activationRegister.successUserMessages.password'));

    ; __line = 19
    ; __append("<div>\n<ul>\n")
    ; __line = 21
    ; __append( messages.map(value => `<li>${value}</li>`).join('') )
    ; __append("\n")
    ; __line = 22
    ; 
if(password){

    ; __line = 24
    ; __append("<li class=\"highlight\">")
    ; __append(escapeFn( password ))
    ; __append("</li>")
    ; 
}

    ; __line = 26
    ; __append("\n</ul>\n</div>")
    ; __line = 28
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\credentials\activationDataHandler.ejs

}